import { v4 as uuidv4 } from 'uuid';
import ProjectImg from '../images/Netflix.gif';
import UTrackerImg from '../images/Sneakers.gif';
import GreenCtgImg from '../images/Cyberpunk-3.gif';
import CoinTrackerImg from '../images/Tesla.gif';
import CavinImg from '../images/Non-constructive-Messenger.gif';
import Todo from '../images/Todo.gif';
import Recipes from '../images/Recipes.gif';
import NftStore from '../images/NftStore.gif';

const projects = [
  {
    id: uuidv4(),
    name: 'Sneakers',
    desc: 'For a fashion brand clothing store, shopping cart/product calculation/selection of the best products.React/Context/React-Router/Axios/Loader.',
    img: UTrackerImg,
    links: 'https://github.com/ereminmaksim/React-StoreSneakers'

  },
  {
    id: uuidv4(),
    name: 'Cyberpunk',
    desc: 'With the ability to edit and transfer your pictures to the store selling NFT OpenSea. Project development on web 3.0 nft tokens. Thirdweb/WEB3.0/NFT/Cyberpunk/Axios',
    img: GreenCtgImg,
    links:'https://github.com/ereminmaksim/cyberpunk-nft-web3.0'
  },
  {
    id: uuidv4(),
    name: 'Tesla',
    desc: 'A TESLA-based landing page with React/Redux/styled-components + Animation libraries is so simple (React-Reveal), for the Redux-toolkit + MaterialUI template',
    img: CoinTrackerImg,
    links:'https://github.com/ereminmaksim/Landing-React-Redux-styled-componentsl-'
  },
  {
    id: uuidv4(),
    name: "Non-constructive-Messenger",
    desc: 'This project, it will allow you to chat with your friends, my start and using firebase/react/redux.Firebase/Styled-Components/Beautiful d-n-d/Redux-toolkit/Use-sound/Material-design.',
    img: CavinImg,
    links:'https://github.com/ereminmaksim/Chat-Firebase-GravityFalls'
  },
  {
    id: uuidv4(),
    name: 'Netflix',
    desc: 'development of a Netflix clone, authorization by phone, SMS (captcha), parsing movies with tmdb. Firebase/React-redux (toolkit)/Tailwind.',
    img: ProjectImg,
    links:'https://github.com/ereminmaksim/cinema-react-redux/tree/creating_panel'

  },
  {
    id: uuidv4(),
    name: 'Todo',
    desc: 'To-do list. For notes, with the effect of extraction, the contribution of new cases, as well as the need for deletion when neutralizing. React/Hooks. ',
    img: Todo,
    links:'https://github.com/ereminmaksim/ToDoList_Rect'
  },
  {
    id: uuidv4(),
    name: 'Recipes',
    desc: 'developing an application with recipes of the world cuisine, you just enter the name of the dish, in response you get, ingredients and cooking method, stack: React/Router v6/Styled-Components/Framer/Axios',
    img: Recipes,
    links:'https://github.com/ereminmaksim/ereminrecipesapp'

  },
  {
    id: uuidv4(),
    name: 'NFT-STORE',
    desc: 'coin minting application development for Open Sea NFS store, stack: Next/TS/TailWind/Sanity(CMS)/React-Hot-Toast',
    img: NftStore,
    links:'https://github.com/ereminmaksim/NFTSTORE'

  }
];

export default projects;
